import styled, { css } from 'styled-components';

import { showBamOnlineFeature } from 'services/helpers/featureToggle';
import {
  colorUsage,
  getSpacing,
  NAV_BAR_HEIGHT,
  CASTING_BUTTON_WIDTH,
  CASTING_BUTTON_RIGHT_MARGIN,
  addDesktopDesignStyle,
} from 'stylesheetB2c';

import B2cPlayerArea from '../B2cPlayerArea';
import CookieBanner from './components/CookieBanner';

interface PlayerWrapper {
  isPlaying: boolean;
  isHidden: boolean;
  isCastingRemoteDevice: boolean;
}

interface CookieBannerProps {
  isNewAppBannerVisible: boolean;
}

export const LayoutContainer = styled.div<{ height: number }>`
  background-color: ${colorUsage.blackBackground};
  color: ${colorUsage.whiteText};
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100vw;
  height: 100%;

  /* mobile viewport bug fix */
  height: ${(props) => props.height}px;
  ${addDesktopDesignStyle(
    css`
      flex-direction: row-reverse;
    `,
  )}
`;
LayoutContainer.displayName = 'LayoutContainer';

export const NavigationArea = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  ${addDesktopDesignStyle(css`
    position: relative;
    max-width: 500px;
    min-width: ${getSpacing(70)};
    flex: 1;
  `)}
`;
NavigationArea.displayName = 'NavigationArea';

export const LayoutContent = styled.div`
  flex: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
`;
LayoutContent.displayName = 'LayoutContent';

export const PlayerAreaContainer = styled.div`
  ${addDesktopDesignStyle(css`
    position: relative;
    display: flex;
    flex-direction: column;
    flex: 2;
    height: auto;
    min-width: 0;
    ${
      showBamOnlineFeature()
        ? css`
          border-left: solid 2px ${colorUsage.webPlayer.playerAreaBorder};
        `
        : css`
          border-left: solid 2px ${colorUsage.playerAreaBorder};
        `
    }
  `)}
`;
PlayerAreaContainer.displayName = 'PlayerAreaContainer';

export const StyledB2cPlayerArea = styled(B2cPlayerArea)<PlayerWrapper>`
  display: ${({ isPlaying, isHidden, isCastingRemoteDevice }) =>
    isPlaying && !isHidden && !isCastingRemoteDevice ? 'block' : 'none'};
  ${addDesktopDesignStyle(css`
    display: flex;
  `)}
`;
StyledB2cPlayerArea.displayName = 'StyledB2cPlayerArea';

export const BannersContainer = styled.div`
  position: absolute;
  bottom: calc(${getSpacing(3)} + ${NAV_BAR_HEIGHT});
  width: 100%;
  padding: 0 ${getSpacing(4)};
  ${addDesktopDesignStyle(css`
    width: auto;
    left: ${getSpacing(2)};
    right: calc(${getSpacing(2)} + ${CASTING_BUTTON_WIDTH} + ${CASTING_BUTTON_RIGHT_MARGIN});
    padding: 0;
  `)}
`;
BannersContainer.displayName = 'BannersContainer';

export const StyledCookieBanner = styled(CookieBanner)<CookieBannerProps>`
  margin-bottom: ${(props) => (props.isNewAppBannerVisible ? getSpacing(2) : 0)};
`;
